export const PUBLIC_KEY_PEM = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAvi/uoj/wAXtzeKZFwwwF
kVq4Xzgkvz0QFq9mEVNnnvzW6hL0GDjg+zWDOoGdXOV9EXd8jMPO95AUPsD++Cgb
qAIjbaMa15lpLdxupE4+b9bcy3/lPBOO2sfYgYXcdNPHcXAL1TSzBBH/tGBrTyua
2OsiOPQER1nZGjUJIKSotU6pdLvlvBJ6y8KWRIxVmPAZTrkWgLel0Ccvd9xM8D3X
zYOJ6E3Uf4G1bt5w2p0Uh6k0j4zvj5jebXsp9VuLApdkob1d10chwM6Nu6dyDN9X
f9Z3qHUJxNbizrtZ2l+8+8jbdGwj5y4MViXPMyN6tnNvqTjdL4SVRXc3EftgRGXX
jQIDAQAB
-----END PUBLIC KEY-----`;